var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"object_header"},[_c('h2',[_vm._v("Описание квартир")]),(_vm.data.description)?_c('div',{staticClass:"object_header__info"},[_c('EditorJSArticleComponent',{attrs:{"text":JSON.parse(_vm.data.description)}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }